exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".ResetPassword[data-v-c37a4516]{text-align:center;margin-top:24px;padding-top:24px}.ResetPassword__Link[data-v-c37a4516]{margin:0 auto;color:#2e80d4;font-weight:700;cursor:pointer}", ""]);
